import { render, staticRenderFns } from "./ColumnLayout.vue?vue&type=template&id=4fa5cae0"
import script from "./ColumnLayout.vue?vue&type=script&lang=js"
export * from "./ColumnLayout.vue?vue&type=script&lang=js"
import style0 from "./ColumnLayout.vue?vue&type=style&index=0&id=4fa5cae0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports